"use client";

import { PropsWithChildren, useEffect } from "react";
import { AppProgressBar as ProgressBar } from "next-nprogress-bar";
import { ChakraProvider } from "@chakra-ui/react";
import { SessionProvider } from "next-auth/react";
import system from "../theme";
import { Config } from "../graphql/generated/graphql";
import { initialisePaddle } from "../lib/paddleClient";
import { ApolloWrapper } from "./ApolloWrapper";
import { ConfigProvider } from "./ConfigProvider";

type Props = {
  config: Config;
};

const Providers: React.FC<PropsWithChildren<Props>> = ({
  config,
  children,
}) => {
  useEffect(() => {
    initialisePaddle();
  }, []);

  return (
    <ApolloWrapper>
      <ConfigProvider config={config}>
        <ChakraProvider value={system}>
          <SessionProvider>{children}</SessionProvider>
        </ChakraProvider>
      </ConfigProvider>
      <ProgressBar
        height="4px"
        color="#e2ab00"
        options={{ showSpinner: false }}
        shallowRouting
      />
    </ApolloWrapper>
  );
};

export default Providers;
